var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title mb-5"},[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.users.title')))]),_c('user')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }